function buildBuka20Url(url) {
  const buka20url = new URL(url);

  const deviceId = localStorage.getItem('device_id');
  buka20url.searchParams.append('device_id', deviceId);

  const otpKey = localStorage.getItem('otp_key');
  buka20url.searchParams.append('otp_key', otpKey);

  return buka20url.href;
}

export default buildBuka20Url;
